// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/ShadersInclude/pbrDirectLightingSetupFunctions.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'pbrDirectLightingSetupFunctions';
const shader = `struct preLightingInfo
{
vec3 lightOffset;
float lightDistanceSquared;
float lightDistance;
float attenuation;
vec3 L;
vec3 H;
float NdotV;
float NdotLUnclamped;
float NdotL;
float VdotH;
float roughness;
#ifdef IRIDESCENCE
float iridescenceIntensity;
#endif
};
preLightingInfo computePointAndSpotPreLightingInfo(vec4 lightData, vec3 V, vec3 N) {
preLightingInfo result;
result.lightOffset = lightData.xyz - vPositionW;
result.lightDistanceSquared = dot(result.lightOffset, result.lightOffset);
result.lightDistance = sqrt(result.lightDistanceSquared);
result.L = normalize(result.lightOffset);
result.H = normalize(V + result.L);
result.VdotH = saturate(dot(V, result.H));
result.NdotLUnclamped = dot(N, result.L);
result.NdotL = saturateEps(result.NdotLUnclamped);
return result;
}
preLightingInfo computeDirectionalPreLightingInfo(vec4 lightData, vec3 V, vec3 N) {
preLightingInfo result;
result.lightDistance = length(-lightData.xyz);
result.L = normalize(-lightData.xyz);
result.H = normalize(V + result.L);
result.VdotH = saturate(dot(V, result.H));
result.NdotLUnclamped = dot(N, result.L);
result.NdotL = saturateEps(result.NdotLUnclamped);
return result;
}
preLightingInfo computeHemisphericPreLightingInfo(vec4 lightData, vec3 V, vec3 N) {
preLightingInfo result;
result.NdotL = dot(N, lightData.xyz) * 0.5 + 0.5;
result.NdotL = saturateEps(result.NdotL);
result.NdotLUnclamped = result.NdotL;
#ifdef SPECULARTERM
result.L = normalize(lightData.xyz);
result.H = normalize(V + result.L);
result.VdotH = saturate(dot(V, result.H));
#endif
return result;
}
vec3 getMRPSpecular(vec3 fragmentPositionW, vec3 lineA, vec3 lineB, vec3 R)
{
vec3 positionToLineA = lineA - fragmentPositionW;
vec3 lineAtoLineB = lineB - lineA;
float tNum = dot(R, lineA) * dot(lineAtoLineB, R) + dot(lineAtoLineB, fragmentPositionW) * dot(R, R) - dot(R, fragmentPositionW) * dot(lineAtoLineB, R) - dot(lineAtoLineB, lineA) * dot(R, R);
float tDenom = dot(lineAtoLineB, lineAtoLineB) * dot(R, R) - dot(lineAtoLineB, R) * dot(lineAtoLineB, R);
float t = clamp((tNum / tDenom), 0.0, 1.0);
return lineA + lineAtoLineB * t;
}
vec3 getClosestPointOnLine(vec3 pointW, vec3 lineA, vec3 lineB) {
vec3 lineAToB = lineB - lineA;
vec3 lineAToPoint = pointW - lineA;
float t = dot(lineAToPoint, lineAToB) / dot(lineAToB, lineAToB);
t = clamp(t, 0.0, 1.0);
return lineA + lineAToB * t;
}
vec3 getMRPDiffuse(vec3 fragmentPositionW, vec3 lineA, vec3 lineB)
{
vec3 positionToLineA = lineA - fragmentPositionW;
vec3 positionToLineB = lineB - fragmentPositionW;
vec3 lineAtoLineB = lineB - lineA;
float aLen = length(positionToLineA);
float bLen = length(positionToLineB);
float t = clamp((aLen / (bLen + aLen)), 0.0, 1.0);
return lineA + lineAtoLineB * t;
}
float getLineLightFalloff(vec3 fragmentPositionW, vec3 closestLinePoint, vec3 lineA, vec3 lineB, vec3 lineNormal, float segmentAngle, float hardSideCuttoff) {
vec3 pointLocalFrameB = lineB - fragmentPositionW;
vec3 lineAToB = lineB - lineA;
float projectionAToB = dot(normalize(lineAToB), pointLocalFrameB);
vec3 pointToLine = normalize(fragmentPositionW - closestLinePoint);
float pointToLineDot = dot(pointToLine, lineNormal);
float hardCutoff = cos(segmentAngle * 2.0 * 3.1415 / 360.0);
if ((projectionAToB < 0.0 || projectionAToB > length(lineAToB)) && hardSideCuttoff == 1.0 || pointToLineDot < hardCutoff) {
return 0.0;
} else {
float smoothCutoff = cos((segmentAngle * 0.5) * 2.0 * 3.1415 / 360.0);
return max(1.0 - smoothstep(smoothCutoff, hardCutoff, pointToLineDot), 0.0);
}
}
preLightingInfo computeLineLightDiffusePreLightingInfo(vec3 mrpDiffuseLightPoint, vec3 N) {
preLightingInfo result;
result.lightOffset = mrpDiffuseLightPoint - vPositionW;
result.lightDistanceSquared = dot(result.lightOffset, result.lightOffset);
result.lightDistance = sqrt(result.lightDistanceSquared);
result.L = normalize(result.lightOffset);
result.NdotLUnclamped = dot(N, result.L);
result.NdotL = saturateEps(result.NdotLUnclamped);
return result;
}
preLightingInfo computeLineLightSpecularPreLightingInfo(vec3 V, vec3 N, vec3 R, vec3 lineA, vec3 lineB) {
preLightingInfo result;
vec3 mrpSpecularLightPoint = getMRPSpecular(vPositionW, lineA, lineB, R);
result.lightOffset = mrpSpecularLightPoint - vPositionW;
result.lightDistanceSquared = dot(result.lightOffset, result.lightOffset);
result.lightDistance = sqrt(result.lightDistanceSquared);
result.L = normalize(result.lightOffset);
result.H = normalize(V + result.L);
result.VdotH = saturate(dot(V, result.H));
result.NdotLUnclamped = dot(N, result.L);
result.NdotL = saturateEps(result.NdotLUnclamped);
return result;
}`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const pbrDirectLightingSetupFunctions = { name, shader };
//# sourceMappingURL=pbrDirectLightingSetupFunctions.js.map